<template>
  <div>
    <!-- row de las 2 columnas: -->
    <el-row
      class="container"
      style="margin-top:15px;"
      :gutter="5"
      type="flex"
      justify="start"
    >
      <!-- Col de la izquierda con los filtros: -->

      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="4">
        <!-- titulo + boton Add -->
        <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t("NAVBAR_resumenDeCuenta") }}</div>
          </el-col>
        </el-row>

        <!-- Busqueda simple -->
        <el-row>
          <el-collapse v-model="activeCollapse" style="margin-bottom: 5px;">
            <el-collapse-item
              class="busqueda"
              :title="$t('GENERAL_Busqueda_Simple')"
              name="1"
              :disabled="disableCollapse"
            >
              <!-- Filtros de la busqueda: -->
              
              <div class="filters">
                <div v-if="buscarClientesLocal">
                  <div class="filters_item">
                    <div class="label">{{ $t('RESUMENDECUENTA_clientes') }}</div>
                    <!--Selector autocomplete para elegir el cliente-->
                    <el-select
                      class="seleccionador"
                      v-model="clienteSeleccionado"
                      filterable
                      reserve-keyword
                      :placeholder="$t('RESUMENDECUENTA_clientes_placeholder')"                  
                      remote
                      size="small"
                      :remote-method="remoteMethod"
                      @change="getCuentasClientesDelayed"
                      value-key="Id"
                    >
                      <el-option
                        v-for="item in clientesOption"
                        :key="item.Id"
                        :label="item.RazonSocial"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>

                  <div class="filters_item" v-if="clienteSeleccionado != undefined && buscarClientesLocal">
                    <div class="label">{{ $t('RESUMENDECUENTA_cuentas') }}</div>
                    <!--Selector para elegir la cuenta del cliente seleccionado-->
                    <el-select
                      class="seleccionador"
                      :placeholder="$t('RESUMENDECUENTA_cuentas_placeholder')"
                      v-model="filtros.cuenta"
                      size="small"
                      :loading="loadingCuentas"
                      @change="getDocumentosDelayed"
                      clearable
                      value-key="Id">
                        <el-option
                        v-for="item in cuentas"
                        :key="item.Id"
                        :label="item.Descripcion"
                        :value="item"
                        ></el-option>
                    </el-select>
                  </div>
                </div>
                <div v-else>
                  <!-- Filtro de Cuentas: -->
                <div class="filters_item">
                  <div class="label">{{ $t("RESUMENDECUENTA_cuenta") }}</div>
                  <el-select
                    class="seleccionador"
                    v-model="filtros.cuenta"
                    size="small"
                    :loading="loadingCuentas"
                    @change="getDocumentosDelayed"
                    :disabled="disableCollapse"
                    :placeholder="$t('RESUMENDECUENTA_cuenta_sin_confirmar')"
                    value-key="Id"
                  >
                    <el-option
                      v-for="cuenta in cuentas"
                      :key="cuenta.Id"
                      :label="cuenta.Descripcion"
                      :value="cuenta"
                    >
                    </el-option>
                  </el-select>
                </div>

                </div>
                

                <!-- Filtro Periodo de tiempo -->
                <div class="filters_item">
                  <!-- checkbox -->
                  <el-row type="flex" align="middle" style="text-align:left;">
                      <el-checkbox
                        v-model="filtros.checkPeriodo"
                        size="medium"
                        @change="changeCheck('P')"
                        :disabled="disableCollapse"
                      >
                      </el-checkbox>

                    <!-- dropDown periodos -->
                      <el-dropdown
                        trigger="click"
                        @command="changePeriodo"
                        :disabled="disableCollapse"
                      >
                        <span
                          :class="{
                            'el-dropdown-link': filtros.checkPeriodo,
                            'el-dropdown-link-active': !filtros.checkPeriodo,
                          }"
                        >
                          {{ this.$t(filtros.periodo) }}
                          <el-icon><ArrowDown /></el-icon>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              command="RESUMENDECUENTA_periodo_meses_1"
                              :disabled="filtros.checkRango"
                              >{{
                                $t("RESUMENDECUENTA_periodo_meses_1")
                              }}</el-dropdown-item
                            >
                            <el-dropdown-item
                              command="RESUMENDECUENTA_periodo_meses_2"
                              :disabled="filtros.checkRango"
                              >{{
                                $t("RESUMENDECUENTA_periodo_meses_2")
                              }}</el-dropdown-item
                            >
                            <el-dropdown-item
                              command="RESUMENDECUENTA_periodo_meses_3"
                              :disabled="filtros.checkRango"
                              >{{
                                $t("RESUMENDECUENTA_periodo_meses_3")
                              }}</el-dropdown-item
                            >
                            <el-dropdown-item
                              command="RESUMENDECUENTA_periodo_ultimos_2a�os"
                              :disabled="filtros.checkRango"
                              >{{
                                $t("RESUMENDECUENTA_periodo_ultimos_2a�os")
                              }}</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                  </el-row>
                </div>

                <div class="filters_item">
                  <el-row style="text-align:left; vertical-align:top;">
                      <el-row>
                        <el-checkbox
                          v-model="filtros.checkRango"
                          size="medium"
                          @change="changeCheck('R')"
                          :disabled="disableCollapse"
                        >
                        </el-checkbox>
                      </el-row>
                      <el-row>
                        <div class="label" style="padding-top:3px !important;">
                          {{ $t("GENERAL_desde") }}
                        </div>
                        <el-date-picker
                          style="width:90%"
                          v-model="filtros.from"
                          type="date"
                          size="small"
                          format="DD/MM/YYYY"
                          suffix-icon="Calendar"
                          placeholder="dd/mm/aaaa"
                          @input="getDocumentosDelayed"
                          @change="getDocumentosDelayed"
                          :picker-options="pickerOptionsFrom"
                          :disabled="filtros.checkPeriodo"
                        />
                      </el-row>
                      <el-row>
                        <div class="label">{{ $t("GENERAL_hasta") }}</div>
                        <el-date-picker
                          v-model="filtros.to"
                          style="width:90%"
                          type="date"
                          size="small"
                          format="DD/MM/YYYY"
                          suffix-icon="Calendar"
                          placeholder="dd/mm/aaaa"
                          @input="getDocumentosDelayed"
                          @change="getDocumentosDelayed"
                          :picker-options="pickerOptionsTo"
                          :disabled="filtros.checkPeriodo"
                        />
                      </el-row>
                  </el-row>
                </div>

                <!-- Limpiar filtros: -->
                <div class="clearFilters" @click="cleanFilters">
                  {{ $t("GENERAL_clean_filters") }}
                </div>
              </div>
            </el-collapse-item>

            <!--Export a Excel-->
            <el-collapse-item
              class="busqueda"
              :title="$t('RESUMENDECUENTA_exportar')"
              name="2"
            >
              <el-button
                class="btnExportarExcel"
                type="primary"
                size="large"
                @click="exportExcel"
                round
                style="margin-top: 1rem;"
              >
                {{ $t("RESUMENDECUENTA_descargar_excel") }}
                <el-icon v-if="!estaDescargandoExcel"><Notebook /></el-icon>
                <el-icon v-else class="is-loading"><Loading /></el-icon>
              </el-button>
            </el-collapse-item>
            <!-- Busqueda Avanzada -->
          </el-collapse>
        </el-row>
      </el-col>
      <!-- Columna tabla Documentos -->
      <el-col class="container_col_2" :span="20">
        <div
          v-if="initialLoad"
          v-loading.lock="initialLoad"
          class="loader"
        ></div>
        <div v-else>
          <!-- row para la vista que no son de celulares  -->
          <el-row class="hidden-xs-only" style="margin:10px auto;" type="flex" justify="space-between">
            <!-- col nombre de la cuenta y doc selecionado -->
            <el-col :sm="24" :md="16">
              <div class="sub-title" v-if="buscarClientesLocal && clienteSeleccionado && filtros.cuenta">
                {{clienteSeleccionado.RazonSocial}} -  {{clienteSeleccionado.Clave}} | {{ nombreDeLaCuenta }} {{ formaDePago }}
              </div>
              <div class="sub-title" v-else-if="filtros.cuenta">
                {{ nombreDeLaCuenta }} {{ formaDePago }}
              </div>
              <div class="caption" v-if="datosUsuario && documentos">
                {{$t('RESUMENDECUENTA_razonSocial') + ": " + datosUsuario.RazonSocial + " - " + $t('RESUMENDECUENTA_CodigoEmpresa') + ": " + datosUsuario.Clave}}
              </div>         
              <div class="caption" v-if="documentoSeleccionado">
                {{ this.$t("RESUMENDECUENTA_label_documento_seleccionado") + documentoSeleccionado }}
              </div>
            </el-col>

            <!-- col paginador arriba documentos -->
            <el-col
              :sm="24"
              :md="8"
              class="pagination_container"
            >
              <el-button style="margin-bottom: 5px" class="realizar-consulta-btn" @click="realizarConsulta">{{$t('RESUMENDECUENTA_RealizarConsulta')}}</el-button>
              <el-pagination
                v-if="documentos && documentos.length"
                background
                small
                layout="prev, pager, next"
                :current-page="paginador.page"
                :page-count="paginador.nro_pages"
                :page-size="paginador.pageSize"
                @current-change="handlePageChange"
                :hide-on-single-page="true"
                :pager-count="5"
              ></el-pagination>
              <el-row v-if="documentoSeleccionado" type="flex" justify="end" align="bottom" style="height: 100%">
                <div style="margin-right: 15px" class="sub-title">
                  Total:
                </div>
                <div class="sub-title" style="margin-right: 5px">
                  {{ $filters.formatPrice(montoACancelar) }}
                </div>
              </el-row>
            </el-col>
          </el-row>
          <!-- row para la vista desde un celular  -->
          <el-row class="hidden-sm-and-up">
              <div class="sub-title" v-if="filtros.cuenta">
                {{ nombreDeLaCuenta }} {{ formaDePago }}
              </div>
              <div class="caption" v-if="datosUsuario">
                {{$t('RESUMENDECUENTA_razonSocial') + ": " + datosUsuario.RazonSocial + " - " + $t('RESUMENDECUENTA_CodigoEmpresa') + ": " + datosUsuario.Clave}}
              </div>             
              <div class="caption" v-if="documentoSeleccionado">
                {{ this.$t("RESUMENDECUENTA_label_documento_seleccionado") + documentoSeleccionado }}
              </div>
          </el-row>
          <!-- row para la vista desde un celular  -->
          <el-row class="hidden-sm-and-up" type="flex" align="middle" justify="space-between">
            <el-button style="margin-bottom: 5px" class="realizar-consulta-btn" @click="realizarConsulta">{{$t('RESUMENDECUENTA_RealizarConsulta')}}</el-button>
              <el-pagination
                background
                small
                layout="prev, pager, next"
                :current-page="paginador.page"
                :page-count="paginador.nro_pages"
                :page-size="paginador.pageSize"
                @current-change="handlePageChange"
                :hide-on-single-page="true"
                :pager-count="5"
              ></el-pagination>
          </el-row>
          <!-- row para la vista desde un celular  -->
          <el-row class="hidden-sm-and-up" v-if="documentoSeleccionado" type="flex" justify="end" align="bottom" style="height: 100%">
            <div style="margin-right: 15px" class="sub-title">
              Total:
            </div>
            <div class="sub-title" style="margin-right: 5px">
              {{ $filters.formatPrice(montoACancelar) }}
            </div>
          </el-row>

          <!-- Tabla Documentos-->
          <div v-if="!documentoSeleccionado">
            <el-table
              :data="documentos"
              border
              show-summary
              sum-text=" "
              :summary-method="getSummaries"
              header-row-class-name="table-header"
              :header-cell-style="headerCellStyle"
              :cell-style="coloreoReferencia"
              v-loading="loadingResumen"
              row-class-name="tablaResumen"
              :empty-text="$t('EL_TABLE_sin_datos')"
             
              :row-style="tableRowStyle"
            >
              <el-table-column
                prop="Fecha"
                :label="$t('RESUMENDECUENTA_tabla_fecha')"
                width="100"
                sortable
              >
                <template #default="scope">
                  {{ $filters.formatDate(scope.row.Fecha) }}
                </template>
              </el-table-column>

              <el-table-column
                prop="DocuTipo"
                :label="$t('PENDIENTES_tipo')"
                width="55"
              >
                <template #default="scope">
                  {{ scope.row.DocuTipo }}
                </template>
              </el-table-column>

              <el-table-column
                prop="DocuSerie"
                :label="$t('PENDIENTES_serie')"
                width="60"
              >
                <template #default="scope">
                  {{ scope.row.DocuSerie }}
                </template>
              </el-table-column>

              <el-table-column
                prop="DocuSuc"
                :label="$t('PENDIENTES_suc')"
                width="70"
              >
                <template #default="scope">
                  {{ scope.row.DocuSuc }}
                </template>
              </el-table-column>

              <el-table-column
                prop="DocuNum"
                :label="$t('PENDIENTES_numero')"
                width="80"
              >
                <template #default="scope">
                  {{ scope.row.DocuNum }}
                </template>
              </el-table-column>

              <el-table-column
                prop="DocuCateg"
                width="55"
              >
                <template #default="scope">
                  {{ scope.row.DocuCateg }}
                </template>
              </el-table-column>

              <el-table-column
                width="85"
                :label="$t('RESUMENDECUENTA_tabla_acciones')"
              >
                <template #default="scope">
                  <div v-if="scope.row.Id !== -1" style="display: flex; justify-content: center; align-items: center; gap: 4px;">
                    <el-tooltip
                      v-if="scope.row.DocuTipo == 'RE'"
                      effect="dark"
                      :content="$t('RESUMENDECUENTA_verRecibo')"
                    >
                      <el-button
                        :loading="obteniendoRecibo == scope.row.ObjectoId"
                        class="btn-acciones"
                        icon="View"
                        @click="verDocumento(scope.row.ObjectoId)"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      v-else
                      effect="dark"
                      :content="$t('RESUMENDECUENTA_descargarFactura')"
                    >
                      <el-button
                        :loading="descargandoFactura == scope.row.ObjectoId"
                        class="btn-acciones"
                        icon="Download"
                        @click="descargarFactura(scope.row.ObjectoId)"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      :content="$t('RESUMENDECUENTA_verCancelaciones')"
                    >
                      <el-button
                        icon="Tickets"
                        class="btn-acciones"
                        @click="mostrarCancelaciones(scope.row)"
                      ></el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="Descripcion"
                :label="$t('RESUMENDECUENTA_tabla_descripcion')"
                width="110"
              >
              </el-table-column>

              <el-table-column
                prop="Debe"
                :label="$t('RESUMENDECUENTA_tabla_debe')"
                width="130"
                align="right"
                class-name="money-cell"
              >
                <template #default="scope">
                  {{ $formatPrice($descarteNulo(scope.row.Debe)) }}
                </template>
              </el-table-column>

              <el-table-column
                prop="Haber"
                :label="$t('RESUMENDECUENTA_tabla_haber')"
                width="130"
                align="right"
                class-name="money-cell"
              >
                <template #default="scope">
                  <span v-if="scope.row.Id !== -1">{{ $formatPrice($descarteNulo(scope.row.Haber)) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="Saldo"
                :label="$t('RESUMENDECUENTA_saldo')"
                min-width="110"
                align="right"
                class-name="money-cell"
              >
                <template #default="scope">
                  {{ $formatPrice($descarteNulo(scope.row.Saldo)) }}
                </template>
              </el-table-column>
            </el-table>

            <!-- Ultima fila "Diferencia Haber - Debe:  $xx.xxx,xx" -->
            <!--<el-row
              type="flex"
              justify="space-between"
              class="ultimaRowDiferenciaHaberMenosDebe"
              v-if="documentos.length"
            >
              <div style="text-align:left; margin: auto 10px; width: 300px;">
                {{ $t("RESUMENDECUENTA_tabla_diferencia_haber_debe") }}
              </div>
              <div
                style="text-align: center; margin: auto 100px; width: 100px;"
              >
                {{ $formatPrice(diferenciaHaberDebe) }}
              </div>
            </el-row>-->
          </div>

          <!-- Tabla Cancelaciones-->
          <div v-if="documentoSeleccionado">
            <el-row
              type="flex"
              justify="center"
              v-loading="loadingCancelaciones"
            >
              <!-- row tabla -->
              <el-table
                :data="filasTablaCancelaciones"
                border
                header-row-class-name="table-header"
                row-class-name="tablaCancelaciones"
                :empty-text="$t('EL_TABLE_sin_datos')"
                :header-cell-style="() => 'text-align: left;'"
              >
                <el-table-column
                  prop="DocuTipo"
                  :label="$t('RESUMENDECUENTA_tabla_cancelaciones_documento')"
                >
                  <template #default="scope">
                    {{
                      scope.row.TipoDocumento +
                        " " +
                      scope.row.SerieDocumento +
                        " " +
                        scope.row.DocumentoSuc +
                        " " +
                        scope.row.NumeroDocumento
                    }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="Cuota"
                  :label="$t('RESUMENDECUENTA_tabla_cancelaciones_cuoata')"
                >
                  <template #default="scope">
                    {{ scope.row.NumeroCuota }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="Vence"
                  :label="$t('RESUMENDECUENTA_tabla_cancelaciones_vence')"
                >
                  <template #default="scope">
                    {{ $filters.formatDate(scope.row.VencimientoCuota) }}
                  </template>
                </el-table-column>

                <el-table-column
                  prop="Cancelado"
                  :label="$t('RESUMENDECUENTA_tabla_cancelaciones_cancelado')"
                  align="right"
                >
                  <template #default="scope">
                    {{ $filters.formatPrice(scope.row.ImporteCancelacion) }}
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-row
                type="flex"
                justify="space-between"
                align="middle"
                class="ultimaRowDiferenciaHaberMenosDebe"
              >
                <div style="margin-left: 10px">
                  {{$t('RESUMENDECUENTA_montoSinImputar')}}
                </div>
                <div
                  style="text-align: right; margin-right: 10px"
                >
                  {{ $filters.formatPrice(montoSinImputar) }}
                </div>
              </el-row>
            <!-- Row Boton cancelar -->
            <el-row type="flex" justify="left">
              <el-button
                style="margin: 10px 0"
                @click="cerrarTablaCancelaciones"
                >{{ $t("GENERAL_volver") }}</el-button
              >
            </el-row>
          </div>

          <!-- Paginador abajo -->
          <el-row v-if="documentos && documentos.length" style="margin:10px auto;" type="flex" justify="end">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              :hide-on-single-page="true"
            ></el-pagination>
          </el-row>
        </div>
      </el-col>

      <!-- termina col derecha -->
    </el-row>
    <ReciboDialog
      :visible="mostrarReciboDialog"
      :recibo="getRecibo"
      :onClose="onCloseCancelar"
      append-to-body
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ReciboDialog from "../Dialog/reciboDialog.vue";
import i18n from "../../plugins/i18n";
import { showError } from "../Mensaje";
import { tienePermiso } from '../../security/autorizador';
import { targets } from "../../security/target";

let defaultPaginador = {
  page: 1,
  nro_pages: 1,
  pageSize: 10,
};

const getDefaultDateRange = () => {
  const today = new Date();
  return {
    from: new Date(today.getFullYear(), today.getMonth() - 1, 1),
    to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
  };
};

const getDefaultFilters = () => {
  const { from, to } = getDefaultDateRange();
  return {
    cuenta: undefined,
    from,
    to,
    periodo: "RESUMENDECUENTA_periodo_meses_1",
    tipo_filtro: "RESUMENDECUENTA_rango",
    ordenar: "",
    checkPeriodo: false,
    checkRango: true,
    clientes: undefined,
    clienteSeleccionado: undefined,
    clientesOption: undefined,
  };
};

export default {
  name: "ResumenDeCuenta",
  components: {
    ReciboDialog,
  },
  props: {
    buscarClientes: {type: Boolean, default: false}
  },
  data() {
    return {
      documentos: undefined,
      cuentas: [],
      diferenciaHaberDebe: "",
      paginador: { ...defaultPaginador },
      filtros: getDefaultFilters(),
      activeCollapse: ["1"],
      initialLoad: true,
      loadingCuentas: true,
      loadingResumen: true,
      loadingCancelaciones: false,
      disableCollapse: false,
      opened: false,
      pickerOptionsFrom: {
        disabledDate: this.disabledDateFrom,
      },
      pickerOptionsTo: {
        disabledDate: this.disabledDateTo,
      },
      documentoSeleccionado: undefined,
      idDocumento: undefined,
      filasTablaCancelaciones: [],
      mostrarReciboDialog: false,
      recibo: {
        Cabecera: {},
        Detalles: [],
      },
      descargandoFactura: undefined,
      obteniendoRecibo: undefined,
      descargandoExcel: false,
      montoACancelar: 0,
      montoSinImputar: 0,
      totalDebe: 0,
      totalHaber: 0,
      datosUsuario: undefined,
      //Clientes
      clientes: [],
      clienteSeleccionado: undefined,
      clientesOption: [],
      buscarClientesLocal: this.buscarClientes,
    };
  },
  computed: {
    ...mapState({
      idUsuario: (state) => state.sesion.resultadoAutenticacion.IdUsuario,
    }),
    ...mapState({
      filtrosResumenDeCuenta: (state) =>
        state.resumenDeCuenta.filtrosResumenDeCuenta,
    }),
    ...mapState({
      paginadorDocumentos: (state) => state.resumenDeCuenta.paginadorDocumentos,
    }),
    ...mapState({
      paginadorCancelaciones: (state) =>
        state.resumenDeCuenta.paginadorCancelaciones,
    }),
    mod() {
      return this.buscarClientesLocal ? "clientes" : "resumenDeCuenta";
    },
    nombreDeLaCuenta() {
      return this.filtros.cuenta ? this.filtros.cuenta.Descripcion : undefined;
    },
    formaDePago() {
      return this.filtros.cuenta ?` - ${this.filtros.cuenta.FormaPago}` :undefined;
    },
    getRecibo() {
      return this.recibo;
    },
    estaDescargandoExcel() {
      return this.descargandoExcel;
    },
    cuentaCorriente() {
      if (!this.cuentas || !this.cuentas.length) return "";
      //buscamos el nombre de la cuenta corriente por el Id
      const nombreCuentaCorriente = this.cuentas.filter(
        (cuenta) => cuenta.Id == this.filtros.cuenta
      )[0];
      return !nombreCuentaCorriente ? "" : nombreCuentaCorriente.Descripcion;
    },
  },
  methods: {
    headerCellStyle() {
      return { "text-align": "center" };
    },
    getDatosUsuario() {
      this.$store.dispatch('sesion/getDatosUsuario', this.idUsuario).then((data) => {
        this.datosUsuario = data;
      })
    },
    realizarConsulta() {
      this.$router.push({name: 'Contacto', params: {cuenta: this.filtros.cuenta.Descripcion}});
    },
    coloreoReferencia ({row, column}) {
        if (column.property === "DocuCateg") {
          if(row.DocuCateg !== ""){
            return {
                background: '#ffbbbb'
                }
          }     
        }
    },
    tableRowStyle() {
      return 'padding: 5px 0px !important;'
    },
    exportExcel() {
      this.descargandoExcel = true;
      let idioma = i18n.locale;
      let index = Math.floor(Math.random() * (9999 - 1) + 1);

      if (this.filtros.cuenta === undefined) {
        showError(this.$t("PENDIENTES_error_exportar1"));
        this.descargandoExcel = false;
        return;
      }
      let payload = {};
      payload.idCuenta = this.filtros.cuenta.Id;
      payload.nombreCuenta = this.nombreDeLaCuenta;
      payload.formaDePago = this.formaDePago,
      payload.razonSocial = this.datosUsuario.RazonSocial,
      payload.clave = this.datosUsuario.Clave,
      payload.page = this.paginador.page;
      payload.idioma = idioma;
      payload.paginar = false;

      //RESUMENDECUENTA_rango - RESUMENDECUENTA_periodo
      if (this.filtros.tipo_filtro !== "RESUMENDECUENTA_periodo") {
        //RESUMENDECUENTA_rango:
        payload.fechaDesde = this.filtros.from;
        payload.fechaHasta = this.filtros.to;

        if (!payload.fechaDesde && !payload.fechaHasta) {
          return;
        }
      } else {
        //RESUMENDECUENTA_periodo:

        payload.fechaHasta = new Date();
        payload.fechaDesde = this.restarMeses(
          payload.fechaHasta,
          this.mapPeriodoToMeses() * -1
        );
        payload.periodo = (this.filtros.checkPeriodo) ?this.mapPeriodoToMeses() :0
      }
      this.$store
        .dispatch(this.mod + "/exportarExcel", payload)
        .then((response) => {
          let link = document.createElement("a");
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" +
            ";base64," +
            encodeURIComponent(response.Datos);
          link.target = "_blank";
          link.setAttribute(
            "download",
            this.$t("NAVBAR_resumenDeCuenta") + "_" + index + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => (this.descargandoExcel = false));
    },
    restarMeses(fechaHasta, mesesARestar) {
      if (mesesARestar == -1) return null; // ese 1 es el que retorna el switch del mapPeriodoToMeses() como default si ningun case (1,2,3,24) entra.

      //retorna una fecha igual a la de fechaHasta  pero restandole la cantidad de meses pasada por parametro. Se usa en el getPedidos para el filtro de Periodo
      let fechaDesde = new Date(fechaHasta);
      let nuevoMes = fechaHasta.getMonth() - mesesARestar;
      fechaDesde.setMonth(nuevoMes);
      return fechaDesde;
    },
    verDocumento(idDocumento) {
      this.obteniendoRecibo = idDocumento;
      if (idDocumento)
        this.$store
          .dispatch(this.mod + "/getRecibo", { idRecibo: idDocumento })
          .then((recibo) => {
            this.recibo = recibo;
            this.mostrarReciboDialog = true;
          })
          .catch(() =>
            showError(this.$t("RESUMENDECUENTA_errorObtencionRecibo"))
          )
          .finally(() => (this.obteniendoRecibo = undefined));
    },
    descargarFactura(idFactura) {
      this.descargandoFactura = idFactura;
      //armo el payload
      let payload = {
        idFactura: idFactura,
      };
      this.$store
        .dispatch(this.mod + "/descargarFactura", payload)
        .then((response) => {
          // obtengo el content type y el file name
          let mimeType = response.headers["content-type"];
          let contentDisposition = response.headers["content-disposition"];
          let fileName = contentDisposition.split("; filename=")[1];
          fileName = fileName.replace(/"/g, "");
          fileName = decodeURIComponent(fileName);

          // genero un blob con la respuesta
          let blob = new Blob([response.data], { type: mimeType });

          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(() => showError(this.$t("RESUMENDECUENTA_errorDescargaFactura")))
        .finally(() => (this.descargandoFactura = undefined));
    },
    mostrarCancelaciones(documentData) {
      //Guardamos el estado del paginador de los documentos
      this.$store.dispatch(
        "resumenDeCuenta/setPaginadorDocumentos",
        this.paginador
      );
      //Cargamos el estado del paginador de las cancelaciones
      this.paginador = { ...defaultPaginador };
      this.idDocumento = documentData.Id;
      this.documentoSeleccionado =
        documentData.DocuTipo +
        " " +
        documentData.DocuSerie +
        " " +
        documentData.DocuSuc +
        " " +
        documentData.DocuNum;
      if(documentData.Debe !== -1)
        this.montoACancelar = documentData.Debe;
      else
        this.montoACancelar = documentData.Haber;
      //this.activeCollapse = ["0"];
      this.disableCollapse = true; // Desabilita el colapsable de los filtros mientras se muestran las tablas de cancelaciones

      this.getContenidoTablaCancelaciones(this.idDocumento);
    },
    onCloseCancelar() {
      this.mostrarReciboDialog = false;
    },
    changeCheck(check) {
      if (check == "P") {
        this.filtros.checkRango =
          this.filtros.checkPeriodo == true ? false : true;
        this.filtros.tipo_filtro = "RESUMENDECUENTA_periodo";
      } else {
        this.filtros.checkPeriodo =
          this.filtros.checkRango == true ? false : true;
        this.filtros.tipo_filtro = "RESUMENDECUENTA_rango";
      }

      if (this.filtros.tipo_filtro === "RESUMENDECUENTA_periodo") {
        this.setDateRangeFromPeriodo();
      }

      this.getDocumentos();
    },
    disabledDateFrom(time) {
      if (this.filtros.to !== "") return time.getTime() > this.filtros.to;
      else return false;
    },

    disabledDateTo(time) {
      if (this.filtros.from !== "") return time.getTime() < this.filtros.from;
      else return false;
    },
    handlePageChange(page) {
      this.paginador.page = page;
      if (this.documentoSeleccionado) {
        this.getContenidoTablaCancelaciones(this.idDocumento);
      } else {
        this.getDocumentos();
      }
    },

    cleanFilters() {
      if (!this.disabled) {
        // limpio los filtros
        this.clienteSeleccionado = undefined
        this.filtros = getDefaultFilters();
        this.filtros.cuenta = undefined;
        this.paginador = { ...defaultPaginador };

        // limpio los resultados de documentos
        this.documentos = [];
      } else {
        this.clienteSeleccionado = undefined
        this.filtros = getDefaultFilters();
        this.filtros.cuenta = undefined;
        this.paginador = { ...defaultPaginador };

        // limpio los resultados de documentos
        this.documentos = [];
      }
    },

    mapPeriodoToMeses() {
      switch (this.filtros.periodo) {
        case "RESUMENDECUENTA_periodo_meses_1":
          return -1;
        case "RESUMENDECUENTA_periodo_meses_2":
          return -2;
        case "RESUMENDECUENTA_periodo_meses_3":
          return -3;
        case "RESUMENDECUENTA_periodo_ultimos_2a�os":
          return -24;
        default:
          return 1;
      }
    },
    setDateRangeFromPeriodo() {
      const fechaHasta = new Date();
      const fechaDesde = this.restarMeses(
        fechaHasta,
        this.mapPeriodoToMeses() * -1
      );

      this.filtros.to = fechaHasta;
      this.filtros.from = fechaDesde;

      return { fechaDesde, fechaHasta };
    },

    getCuentas() {
      this.loadingCuentas = true;
      return this.$store
        .dispatch(this.mod + "/getCuentas", this.idUsuario)
        .then((data) => {
          if (data.CodigoResultado == 0) {
            this.cuentas = data.Datos;
            this.filtros.cuenta =
              this.filtros.cuenta === undefined
                ? this.cuentas[0]
                : this.filtros.cuenta;
          }
        })
        .catch(() =>
          showError(this.$t("RESUMENDECUENTA_errorObtencionCuentas"))
        )
        .finally(() => (this.loadingCuentas = false));
    },

    getDocumentos() {
      if (!this.filtros.cuenta) {
        this.initialLoad = false;
        this.loadingResumen = false;
        return;
      }
      // armo el payload
      let payload = {};
      payload.idCuenta = this.filtros.cuenta.Id;

      //RESUMENDECUENTA_rango - RESUMENDECUENTA_periodo
      if (this.filtros.tipo_filtro !== "RESUMENDECUENTA_periodo") {
        //RESUMENDECUENTA_rango:
        payload.fechaDesde = this.filtros.from;
        payload.fechaHasta = this.filtros.to;

        if (!payload.fechaDesde && !payload.fechaHasta) {
          this.initialLoad = false;
          this.loadingResumen = false;
          return; // El Back acepta recibir solo uno de los dos y el otro en null
        }
      } else {
        //RESUMENDECUENTA_periodo:
        const { fechaDesde, fechaHasta } = this.setDateRangeFromPeriodo();
        payload.fechaHasta = fechaHasta;
        payload.fechaDesde = fechaDesde;
      }
      this.loadingResumen = true;
      payload.page = this.paginador.page;
      payload.pageSize = this.paginador.pageSize;
      payload.periodo = (this.filtros.checkPeriodo) ?this.mapPeriodoToMeses() :0

      // busco los documentos de resumen de cuenta
      this.$store
        .dispatch(this.mod + "/getDocumentos", payload)
        .then((data) => {
          if (data.CodigoResultado == 0) {
            this.totalDebe = data.Datos.TotalDebe;
            this.totalHaber = data.Datos.TotalHaber;
            var paginado = data.Datos.Resumen;
            this.documentos = paginado.Result;
            this.paginador.nro_pages = paginado.TotalPages;
          }
        })
        .catch(() =>
          showError(this.$t("RESUMENDECUENTA_errorObtencionDocumentos"))
        )
        .finally(() => {
          this.initialLoad = false;
          this.loadingResumen = false;
        });
    },
    getDocumentosDelayed() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.paginador = { ...defaultPaginador };
        this.getDocumentos();
      }, 500);
    },

    changePeriodo(periodo) {
      this.filtros.periodo = periodo;

      if (this.filtros.tipo_filtro === "RESUMENDECUENTA_periodo") {
        this.setDateRangeFromPeriodo();
      }

      this.getDocumentos();
    },
    getSummaries(param) {
      // #g1
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("RESUMENDECUENTA_tabla_totales");
          return;
        }
        if (column.property === "Debe") {
          sums[index] = this.$formatPrice(this.totalDebe);
        }
        if (column.property === "Haber") {
          sums[index] = this.$formatPrice(this.totalHaber);
        }
      });
      this.diferenciaHaberDebe = this.totalHaber - this.totalDebe
      return sums;
    },
    cerrarTablaCancelaciones() {
      this.documentoSeleccionado = undefined;
      this.idDocumento = undefined;
      //this.activeCollapse = ["1"];
      this.disableCollapse = false;

      //guardamos el estado del paginador de las cancelaciones
      //this.$store.dispatch("resumenDeCuenta/setPaginadorCancelaciones",this.paginador);

      //cargamos el estado del paginador de los documentos
      this.paginador = this.paginadorDocumentos;

      this.getDocumentos();
    },

    getContenidoTablaCancelaciones(id) {
      // armo el payload
      this.loadingCancelaciones = true;
      let payload = {};
      payload.idItemResumen = id;

      payload.page = this.paginador.page;
      payload.pageSize = this.paginador.pageSize;
      // busco las cancelaciones para el documento seleccionado
      return this.$store
        .dispatch(this.mod + "/getCancelaciones", payload)
        .then((data) => {
          if (data.CodigoResultado == 0) {
            var paginado = data.Datos;
            this.filasTablaCancelaciones = paginado.Result;
            this.paginador.nro_pages = paginado.TotalPages;
            var importeCancelado = 0;
            paginado.Result.forEach(x => importeCancelado += x.ImporteCancelacion);
            this.montoSinImputar = this.montoACancelar - importeCancelado;
            if(this.montoSinImputar < 0)
              this.montoSinImputar = 0;
          }
        })
        .catch(() =>
          showError(this.$t("RESUMENDECUENTA_errorObtencionCancelaciones"))
        )
        .finally(() => (this.loadingCancelaciones = false));
    },
    //Metodos Clientes
    getClientes() {
      return this.$store.dispatch("clientes/getClientes")
        .then( data => {
          if (data.CodigoResultado == 0) {
            this.clientes = data.Datos;
          }
        })
        .catch(() =>
          showError(this.$t("RESUMENDECUENTA_errorObtencionClientes"))
        )
        .finally(() => (this.loadingCuentas = false));
        
    },
    //Una vez seleccionado un cliente, debemos buscar sus cuentas corrientes
    getCuentasCliente(){
      return this.$store.dispatch("clientes/getCuentasCorrientes", this.clienteSeleccionado.Id)
        .then( data => {
          if (data.CodigoResultado == 0) {
            this.cuentas = data.Datos;
          }
        })
        .catch(() =>
          showError(this.$t("RESUMENDECUENTA_errorObtencionCuentas"))
        )
        .finally(() => (this.loadingCuentas = false));
    },
    //Ante un cambio en la seleccion del cliente, debemos consultar las cuentas nuevamente
    getCuentasClientesDelayed(item){
        if (this.buscarClientesLocal) {
          this.filtros.cuenta = undefined
          this.totalDebe = undefined;
          this.totalHaber = undefined;
          this.documentos = undefined;
        }
        
       if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.clienteSeleccionado = item
        this.paginador = { ...defaultPaginador };
        this.getCuentasCliente();
      }, 500);
    },
    remoteMethod(query){
       if (query !== '' && query.length >= 3) {          
          setTimeout(() => {
            this.clientesOption = this.clientes.filter(item => {
              return item.RazonSocial.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.clientesOption = [];
        }
    },
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    //Antes de abandonar la pagina guardamos los filtros
    this.$store.dispatch(
      "resumenDeCuenta/setFiltrosResumenDeCuenta",
      this.filtros
    );
    this.$store.dispatch(
      "resumenDeCuenta/setPaginadorDocumentos",
      this.paginador
    );
  },
  created(){
    // //Scroll para Android
    // document.body.scrollTop = 0;
    // //Scroll para IOS
    // document.documentElement.scrollTop = 0;

    // //recupero el estado de los filtros
    // this.filtros = this.filtrosResumenDeCuenta;
    // this.paginador = this.paginadorDocumentos;

    // tienePermiso(targets.Menu_Clientes) ? this.buscarClientes = true : this.buscarClientes = false;
    
    // if(this.buscarClientes){
    //    this.initialLoad = false;
    //    this.loadingCancelaciones = false;
    //    this.loadingCuentas = false;
    //    this.loadingResumen = false;
    //   /*Request para obtener listado de clientes*/
    //   this.getClientes()
    // }else{
    //    this.initialLoad = true;
    //   //Busco las cuentas del usuario para cargarlas en el dropDown
    //   this.getCuentas().then(() => {
    //   //Busco los documentos
    //   this.getDocumentos();
    // });
    // }
  },
  mounted() {
    this.getDatosUsuario();   

     //Scroll para Android
    document.body.scrollTop = 0;
    //Scroll para IOS
    document.documentElement.scrollTop = 0;

    //recupero el estado de los filtros
    this.filtros = { ...this.filtrosResumenDeCuenta };
    this.paginador = this.paginadorDocumentos;

    tienePermiso(targets.Menu_Clientes) ? this.buscarClientesLocal = true : this.buscarClientesLocal = false;
    
    if(this.buscarClientesLocal){
       this.initialLoad = false;
       this.loadingCancelaciones = false;
       this.loadingCuentas = false;
       this.loadingResumen = false;
      /*Request para obtener listado de clientes*/
      this.getClientes()
    }else{
       this.initialLoad = true;
      //Busco las cuentas del usuario para cargarlas en el dropDown
      this.getCuentas().then(() => {
      //Busco los documentos
      this.getDocumentos();
    });
    }
  },
  watch: {
    buscarClientes(newVal) {
    this.buscarClientesLocal = newVal;
    if(this.buscarClientesLocal){
      this.filtros = getDefaultFilters()
      this.paginador = { ...defaultPaginador}
      this.totalDebe = undefined;
      this.totalHaber = undefined;
      this.documentos = undefined;
      this.initialLoad = false;
      // this.clientes= undefined;
      // this.clienteSeleccionado= undefined;
      // this.clientesOption= undefined;
      /*Request para obtener listado de clientes*/
      this.getClientes()
    }else{
       //recupero el estado de los filtros
       this.initialLoad = true;
      this.filtros = { ...this.filtrosResumenDeCuenta };
      this.paginador = this.paginadorDocumentos;
      //Busco las cuentas del usuario para cargarlas en el dropDown
      this.getCuentas().then(() => {
      //Busco los documentos
      this.getDocumentos();
    });}
    }
  }
};
</script>

<style scoped>
.btn-acciones {
  padding: 5px 5px !important;
}
.btnExportarExcel {
  margin-top: 15px;
  font-size: 14px !important;
  width: 90%;
}
.greyLabel {
  color: #6b6b6b;
  font-weight: normal;
}

.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.seleccionador {
  width: 100%;
  padding: 0;
}
.el-card {
  height: 100%;
}
.cardBody {
  padding-left: 25px;
}

.container {
  display: flex;
  min-height: 500px !important;
  width: 100% !important;
}

.pagination_container {
  text-align: right;
  padding-right: 0px;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}
/* #pendiente: Que es esto del @media? estaba distinto e el presupuesto y en el pedido */
@media (max-width: 1100px) {
  .container_col_1 {
    flex: 1;
    width: 100% !important;
  }
}
@media (max-width: 900px) {
  .busqueda {
    font-size: 10px;
  }
  .container_col_2 {
    flex: 1;
    width: 100% !important;
    margin-top: 20px;
  }
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top: 20px;
  }
  .busqueda {
    font-size: 14px;
  }
}

.card {
  width: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  justify-self: center;
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}

.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
.ordena {
  text-align: right;
  margin-bottom: 20px;
}

.ultimaRowDiferenciaHaberMenosDebe {
  background: #f5f7fa !important;
  height: 50px;
  border: 1px solid #ebeef5;
  font-size: 14px;
  color: #606266;
}
.debeYHaberJustificadoDerecha {
  justify-content: right;
  text-align: right;
}
.caption {
  color: rgba(0, 0, 0, 0.644);
  font-size: 12px;
  text-align: left;
  margin-top: 5px;
}

.tablaCancelacionesRecibo {
  padding: 0 15%;
  background-color: #fff;
}
.tablaCancelacionesFactura {
  padding: 0 35%;
  background-color: #fff;
}
</style>

<style>
.realizar-consulta-btn.el-button {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.money-cell .cell {
  padding-left: 0px;
}
.el-table .tablaResumen td, .el-table .tablaResumen th {
    padding: 5px 0;
}
.el-table .tablaCancelaciones td, .el-table .tablaCancelaciones th {
    padding: 5px 0;
}

.el-table .table-header th .cell {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
  line-height: 2.25;
}

</style>
